import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestAccountMigrationMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type RequestAccountMigrationMutation = { requestAccountMigration: string };


export const RequestAccountMigrationDocument = gql`
    mutation RequestAccountMigration($email: String!) {
  requestAccountMigration(email: $email)
}
    `;
export type RequestAccountMigrationMutationFn = Apollo.MutationFunction<RequestAccountMigrationMutation, RequestAccountMigrationMutationVariables>;

/**
 * __useRequestAccountMigrationMutation__
 *
 * To run a mutation, you first call `useRequestAccountMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountMigrationMutation, { data, loading, error }] = useRequestAccountMigrationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestAccountMigrationMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccountMigrationMutation, RequestAccountMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccountMigrationMutation, RequestAccountMigrationMutationVariables>(RequestAccountMigrationDocument, options);
      }
export type RequestAccountMigrationMutationHookResult = ReturnType<typeof useRequestAccountMigrationMutation>;
export type RequestAccountMigrationMutationResult = Apollo.MutationResult<RequestAccountMigrationMutation>;
export type RequestAccountMigrationMutationOptions = Apollo.BaseMutationOptions<RequestAccountMigrationMutation, RequestAccountMigrationMutationVariables>;